import { HOST_PORTAL_URL } from '../config/api.config';

/** Absolute URL to the host portal sign-in page (Healthcare Portal when FEP is embedded or opened from it). */
export function getHostPortalLoginUrl(): string {
  return `${HOST_PORTAL_URL.replace(/\/$/, '')}/login`;
}
